var _g, _g2, _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout329(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 103,
    viewBox: "0 0 191 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.83 55.99L67.72 55L70.3 55.84V58H61.69V55.84L64.3 55.09L63.88 55.69L62.68 51.79L63.34 52.33H55.42L55.93 51.82L54.64 55.63L54.52 55.18L56.92 55.84V58H49.09V55.84L51.58 55.06L50.62 55.9L57.7 36.94L62.11 36.82L68.83 55.99ZM56.5 49.93L56.2 49.36H62.65L62.23 50.02L59.11 39.19H60.1L56.5 49.93ZM80.8115 47.5L81.0815 47.08C82.4815 47.1 83.6915 47.28 84.7115 47.62C85.7315 47.94 86.5215 48.47 87.0815 49.21C87.6415 49.93 87.9215 50.9 87.9215 52.12C87.9215 53.36 87.6115 54.42 86.9915 55.3C86.3915 56.18 85.4915 56.85 84.2915 57.31C83.0915 57.77 81.6015 58 79.8215 58H70.8515V55.84L73.6415 55.03L73.0715 55.9V39.1L73.7615 40L70.8515 39.19V37.03L77.1815 36.88H80.2715C81.7315 36.88 82.9715 37.07 83.9915 37.45C85.0115 37.81 85.7915 38.38 86.3315 39.16C86.8715 39.92 87.1415 40.9 87.1415 42.1C87.1415 43.74 86.6115 45.01 85.5515 45.91C84.5115 46.79 82.9315 47.32 80.8115 47.5ZM79.4315 39.91H76.7015L77.3615 39.25V46.36L76.7015 45.76H78.7715C79.5315 45.76 80.2115 45.67 80.8115 45.49C81.4315 45.31 81.9215 45 82.2815 44.56C82.6415 44.1 82.8215 43.48 82.8215 42.7C82.8215 41.96 82.6715 41.39 82.3715 40.99C82.0715 40.59 81.6615 40.31 81.1415 40.15C80.6415 39.99 80.0715 39.91 79.4315 39.91ZM79.4315 54.94C80.2115 54.94 80.9115 54.85 81.5315 54.67C82.1515 54.49 82.6415 54.17 83.0015 53.71C83.3615 53.25 83.5415 52.62 83.5415 51.82C83.5415 51.04 83.3815 50.43 83.0615 49.99C82.7415 49.53 82.3315 49.21 81.8315 49.03C81.3315 48.85 80.7815 48.76 80.1815 48.76H76.7015L77.3615 48.01V55.63L76.7015 54.94H79.4315ZM99.433 58.36C97.533 58.36 95.883 57.96 94.483 57.16C93.103 56.34 92.033 55.14 91.273 53.56C90.513 51.98 90.133 50.03 90.133 47.71C90.133 45.85 90.373 44.22 90.853 42.82C91.333 41.42 92.013 40.26 92.893 39.34C93.773 38.4 94.813 37.7 96.013 37.24C97.233 36.76 98.583 36.52 100.063 36.52C101.523 36.52 102.833 36.75 103.993 37.21C105.173 37.67 106.173 38.34 106.993 39.22C107.833 40.1 108.483 41.2 108.943 42.52C109.403 43.82 109.633 45.33 109.633 47.05C109.633 49.39 109.203 51.41 108.343 53.11C107.503 54.79 106.323 56.09 104.803 57.01C103.283 57.91 101.493 58.36 99.433 58.36ZM99.763 55.06C100.763 55.06 101.653 54.82 102.433 54.34C103.213 53.84 103.833 53.02 104.293 51.88C104.773 50.72 105.013 49.17 105.013 47.23C105.013 45.43 104.793 43.99 104.353 42.91C103.933 41.81 103.343 41.02 102.583 40.54C101.823 40.06 100.923 39.82 99.883 39.82C98.883 39.82 97.993 40.06 97.213 40.54C96.433 41.02 95.823 41.82 95.383 42.94C94.963 44.06 94.753 45.6 94.753 47.56C94.753 49.36 94.953 50.81 95.353 51.91C95.753 52.99 96.323 53.79 97.063 54.31C97.823 54.81 98.723 55.06 99.763 55.06ZM123.866 37.03L132.566 36.88V39.04L129.896 39.94L130.376 38.86V49.75C130.376 50.77 130.276 51.72 130.076 52.6C129.896 53.46 129.596 54.25 129.176 54.97C128.756 55.67 128.216 56.28 127.556 56.8C126.896 57.3 126.086 57.69 125.126 57.97C124.186 58.23 123.096 58.36 121.856 58.36C120.196 58.36 118.846 58.16 117.806 57.76C116.766 57.34 115.956 56.81 115.376 56.17C114.796 55.51 114.376 54.81 114.116 54.07C113.876 53.31 113.726 52.59 113.666 51.91C113.626 51.21 113.606 50.62 113.606 50.14V38.89L114.086 39.91L111.386 39.19V37.03L120.086 36.88V39.04L117.476 39.94L117.896 38.89V50.14C117.896 50.66 117.916 51.17 117.956 51.67C118.016 52.15 118.116 52.6 118.256 53.02C118.396 53.42 118.606 53.78 118.886 54.1C119.186 54.4 119.576 54.64 120.056 54.82C120.556 54.98 121.176 55.06 121.916 55.06C122.676 55.06 123.306 54.97 123.806 54.79C124.306 54.61 124.706 54.36 125.006 54.04C125.326 53.7 125.556 53.31 125.696 52.87C125.856 52.43 125.956 51.95 125.996 51.43C126.056 50.89 126.086 50.33 126.086 49.75V38.86L126.476 39.85L123.866 39.19V37.03ZM137.493 58V55.84L140.823 55L140.043 56.08V39.31L140.913 39.97H136.023L136.983 39.13L136.173 42.94H133.623V36.88H150.783V42.94H148.233L147.483 39.31L148.383 39.97H143.493L144.363 39.31V56.08L143.613 55L146.913 55.84V58H137.493Z",
    fill: "#3F3F3F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_131_276)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 40H43.2V36.8H40V40ZM39.2 40H36V36.8H39.2V40ZM35.2 40H32V36.8H35.2V40ZM31.2 40V36.8H24C13.3961 36.8 4.8 45.3961 4.8 56C4.8 66.6039 13.3961 75.2 24 75.2C34.6039 75.2 43.2 66.6039 43.2 56V48.8H40V56C40 64.8366 32.8366 72 24 72C15.1634 72 8 64.8366 8 56C8 47.1634 15.1634 40 24 40H31.2ZM40 48H43.2V44.8H40V48ZM39.2 48.8V56C39.2 64.3947 32.3947 71.2 24 71.2C15.6053 71.2 8.8 64.3947 8.8 56C8.8 47.6053 15.6053 40.8 24 40.8H31.2V44H24C17.3726 44 12 49.3726 12 56C12 62.6274 17.3726 68 24 68C30.6274 68 36 62.6274 36 56V48.8H39.2ZM35.2 44H32V40.8H35.2V44ZM36 40.8V44H39.2V40.8H36ZM36 44.8V48H39.2V44.8H36ZM35.2 56V48.8H32V56C32 60.4183 28.4183 64 24 64C19.5817 64 16 60.4183 16 56C16 51.5817 19.5817 48 24 48H31.2V44.8H24C17.8144 44.8 12.8 49.8144 12.8 56C12.8 62.1856 17.8144 67.2 24 67.2C30.1856 67.2 35.2 62.1856 35.2 56ZM31.2 56C31.2 59.9764 27.9764 63.2 24 63.2C20.0236 63.2 16.8 59.9764 16.8 56C16.8 52.0236 20.0236 48.8 24 48.8H31.2V56ZM32 48V44.8H35.2V48H32ZM40 44H43.2V40.8H40V44Z",
    fill: "#3F3F3F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 76,
    width: 102,
    height: 1,
    transform: "rotate(-180 151 76)",
    fill: "#3F3F3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 71,
    width: 102,
    height: 1,
    transform: "rotate(-180 151 71)",
    fill: "#3F3F3F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 66,
    width: 102,
    height: 1,
    transform: "rotate(-180 151 66)",
    fill: "#3F3F3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_276",
    x: 9.09009,
    y: 0.519531,
    width: 181.693,
    height: 101.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_131_276",
    x: 0.800049,
    y: 36.7998,
    width: 46.3999,
    height: 46.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_276",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout329);
export default __webpack_public_path__ + "static/media/About329.271a191fd4f6ac0cc7bc1e51a3dbde17.svg";
export { ForwardRef as ReactComponent };